var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8598 29.6829H21.5381C26.904 29.6829 27.865 27.5339 28.1453 24.9177L29.1464 14.2393C29.5068 10.9824 28.5725 8.32617 22.8729 8.32617H9.52496C3.82537 8.32617 2.89101 10.9824 3.25141 14.2393L4.2525 24.9177C4.53281 27.5339 5.49387 29.6829 10.8598 29.6829Z",
    stroke: "#003A9B",
    strokeWidth: 2.0022,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8594 8.32576V7.25793C10.8594 4.89533 10.8594 2.98657 15.1307 2.98657H17.2664C21.5378 2.98657 21.5378 4.89533 21.5378 7.25793V8.32576",
    stroke: "#003A9B",
    strokeWidth: 2.0022,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8665 17.6698V19.0046C18.8665 19.0179 18.8665 19.0179 18.8665 19.0313C18.8665 20.4862 18.8532 21.6742 16.1969 21.6742C13.554 21.6742 13.5273 20.4995 13.5273 19.0446V17.6698C13.5273 16.335 13.5273 16.335 14.8621 16.335H17.5317C18.8665 16.335 18.8665 16.335 18.8665 17.6698Z",
    stroke: "#003A9B",
    strokeWidth: 2.0022,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0784 15C25.995 17.2425 22.4711 18.5773 18.8672 19.0311",
    stroke: "#003A9B",
    strokeWidth: 2.0022,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67969 15.3604C6.68298 17.4159 10.0734 18.6573 13.5305 19.0444",
    stroke: "#003A9B",
    strokeWidth: 2.0022,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobIcon);
export default __webpack_public_path__ + "static/media/job-icon.a11c4c432749e0ef7770b548e2b17d1a.svg";
export { ForwardRef as ReactComponent };